package pl.mothdigital.neuronowi.components.sections.specialist

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.common.model.ImageResource
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.common.utils.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.components.layouts.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.theme.*

/**
 * Profile section for specialist pages.
 * Displays specialist's photo and "About Me" information.
 *
 * @param avatar Specialist's profile image
 * @param aboutTitle Title for the about section (default: "O mnie")
 * @param aboutParagraphs List of text paragraphs describing the specialist
 * @param inviteMessage Optional closing invitation message
 * @param imagePosition Position of the avatar image (LEFT or RIGHT)
 */
@Composable
fun SpecialistProfileSection(
    avatar: ImageResource,
    aboutTitle: String = StringResources.SECTION_TITLE_ABOUT_ME,
    aboutParagraphs: List<String>,
    inviteMessage: String? = null,
    imagePosition: ImagePosition = ImagePosition.LEFT
) {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .standardSectionPadding()
            .toAttrs()
    ) {
        ResponsiveImageTextLayout(
            image = avatar,
            imagePosition = imagePosition,
            imageWidth = 400.px,
            imageBorderRadius = 1.cssRem
        ) {
            AppH2 { Text(aboutTitle) }

            aboutParagraphs.forEach { paragraph ->
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(paragraph.fixPolishOrphans()) }
            }

            inviteMessage?.let { message ->
                AppP(
                    color = SiteTheme.green._800,
                    modifier = Modifier.fontWeight(FontWeight.Bold).textAlign(TextAlign.Justify)
                ) {
                    Text(message.fixPolishOrphans())
                }
            }
        }
    }
}
